export const tr = {
    'inconsistent-ad-group-type-to-campaign-type': 'Oluşturulan grubun türü kampanya türüne uygun değil',
    'max-adgroups-in-campaign': 'Kampanyada maksimum grup sayısına ulaşıldı',
    'name-prohibited-symbols': 'Grup adı yasak karakterler içeriyor'
};
